import { QuotaMetricGridContainer, InvoicePerMonthContainer } from "src/app/containers";

const ProofreaderDashboard = () => {
    return (
        <div className="dashboardContainer proofreaderDashboardContainer">
            <QuotaMetricGridContainer />
            <div className="metricsPeryearTableWrapper">
                <InvoicePerMonthContainer />
            </div>
        </div>
    );
};

export default ProofreaderDashboard;
